// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { titleTypographyStyles } from "@ces/App/Components/TitleTypography/TitleTypography";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

titleTypographyStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-end;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 24px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            align-items: flex-start;
        }
    `,
};

titleTypographyStyles.title = {
    variant: "h2",
    color: "text.main",
    css: css`
        margin-right: 32px;
        margin-bottom: 0;
        letter-spacing: 0;
        ${xScreen("lte", "sm")} {
            margin-bottom: 10px;
            margin-right: 0;
        }
    `,
};

titleTypographyStyles.link = {
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.bold,
        css: css`
            letter-spacing: 0;
            line-height: 22px;
        `,
    },
};
